
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCursorOpenHandIcon as ObiCursorOpenHandIconElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cursor-open-hand-icon.js';
 
 
 

 
 export const ObiCursorOpenHandIcon = createComponent({
   react: React,
   tagName: 'obi-cursor-open-hand-icon',
   elementClass: ObiCursorOpenHandIconElement,
   events: {
     
   }
  });
 
 